module.exports = __webpack_public_path__ + "static/media/Import_plots_XLS_HU_HU_LAT.dd74a408.pdf";